export default __webpack_public_path__ + "placeholder-image.svg";